import 'bootstrap/dist/css/bootstrap.css';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { registerLicense } from '@syncfusion/ej2-base';
import AppContext from './helpers/Context';
import ReactGA from "react-ga4";
import { getCurrentDomain } from './helpers/Lookup';
import { L10n, setCulture } from '@syncfusion/ej2-base';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

setCulture('en-ZA'); // South Africa English

L10n.load({
  'en-ZA': {
    grid: {
      EmptyRecord: 'No records to display'
    }
  }
});

registerLicense('Ngo9BigBOggjHTQxAR8/V1JFaF5cXGRCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWH9fdXVVRWRcV0JyXkBWYEg=');
//ReactGA.initialize("G-NF5W2C349C");
ReactGA.initialize("G-EN16VLWYV6");
//ReactGA.send({ hitType: "pageview", page: getCurrentDomain() + "/", title: "Home Page" });
root.render(
    <BrowserRouter basename={baseUrl}>
    <AppContext>
        <App />
    </AppContext>
  </BrowserRouter>);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
